import { render, staticRenderFns } from "./MiniProgramEntry.vue?vue&type=template&id=1a204f34&scoped=true"
import script from "./MiniProgramEntry.vue?vue&type=script&lang=js"
export * from "./MiniProgramEntry.vue?vue&type=script&lang=js"
import style0 from "./MiniProgramEntry.vue?vue&type=style&index=0&id=1a204f34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a204f34",
  null
  
)

export default component.exports